import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

// Presentation only. The owner-bound dock retains the sole authenticated frame.
const AssistantUI = createContext<{
  open: boolean; expanded: boolean; openChat: () => void; closeChat: () => void; toggleExpanded: () => void;
} | null>(null);

export function AssistantUIProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const value = useMemo(() => ({ open, expanded, openChat: () => setOpen(true),
    closeChat: () => setOpen(false), toggleExpanded: () => setExpanded(current => !current) }), [open, expanded]);
  return <AssistantUI.Provider value={value}>{children}</AssistantUI.Provider>;
}
export function useAssistantUI() {
  const value = useContext(AssistantUI);
  if (!value) throw new Error('Assistant controls require the authenticated shell');
  return value;
}
